import { createWebHistory, createRouter } from "vue-router";
import axios from 'axios';
import routes from './routes';
import appConfig from "../../app.config";

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// API based Authentication
// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt'); // for all requests
  // await axios.get('https://api-node.themesbrand.website/profile').then((data) => {
  //   localStorage.setItem('userdata', JSON.stringify(data.data.user));
  //   localStorage.setItem('userid', data.data.user._id);
  //   localStorage.setItem('user', JSON.stringify(data.data.user));
    next();
  // }).catch(() => {
  //   next();
  //   // next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  // });
});

router.beforeEach((routeTo, routeFrom, next) => {

  const publicPages = [
    process.env.VUE_APP_DB_URI + '/login',
    process.env.VUE_APP_DB_URI + '/resetPwd',
    process.env.VUE_APP_DB_URI + '/installation',
    process.env.VUE_APP_DB_URI + '/action-alert-message',
    process.env.VUE_APP_DB_URI + '/activateOTP'];
  const authpage = publicPages.includes(routeTo.path);
  const loggeduser = localStorage.getItem('user');
  const notAddPath = [process.env.VUE_APP_DB_URI + '/detail']

  // 根据发送的邮件中地址，匹配path中包含/#/ 的路由，根据正则匹配，移除掉/#
  if(routeTo.href.includes('/#')) {
    window.location.href =  routeTo.href.replace('/#', '')
  }

  // 在全部挂载之前对路由进行处理
  let pageHistory = JSON.parse(localStorage.getItem('pageHistory'));
  // router.beforeEach((to, from, next) => {
    if(pageHistory) {
      const dataIndex = pageHistory.findIndex(item => item.path === routeTo.path.replace(process.env.VUE_APP_DB_URI, ''));
      if (dataIndex === -1) {
        let maxItem = {};
        if(pageHistory) {
          // 获取已存在的路由中的key值最大的
          maxItem = pageHistory.reduce((prev, current) => {
            return (current.key > prev.key) ? current : prev;
          }, pageHistory[0]);
        }

        const excludedPaths = ['/undefined', '/installation', '/action-alert-message', '/login', '/resetPwd', '/activateOTP'];
        // 检查路径中是否包含excludedPaths数据中的任意一项，如果包含，则不进行记录
        const checkPath = excludedPaths.some(item => routeTo.path.includes(item));
        if(checkPath) {
          return next();
        }

        const pathPrefix = routeTo.path.split('/').slice(0, routeTo.path.indexOf('/charts/') !== -1 ? 2 : 3).join('/'); // 提取路径前缀，例如 /device/detail

        // 检查 pageHistory 中是否已经存在相同的路径
        const existingIndex = pageHistory.findIndex(item => item.path.startsWith(pathPrefix));

        // 检查路径前缀的最后一部分是否在排除列表中
        const isExcluded = excludedPaths.includes(pathPrefix.split('/').pop());

        if (!isExcluded) {
          if (existingIndex !== -1) {
            // 移除已存在的路径记录
            pageHistory.splice(existingIndex, 1);
          }

          // 添加新的路径记录
          pageHistory.push({path: routeTo.path.replace(process.env.VUE_APP_DB_URI, ''), title: routeTo.name, key: maxItem ? maxItem.key + 1 : 1});
          localStorage.setItem('pageHistory', JSON.stringify(pageHistory));
        }

      }
    } else {
      // 添加新的路径记录
      pageHistory = [];
      if(routeTo.path === '/login') return
      pageHistory.push({path: '/', title: 'dashboard', key: 1});
      localStorage.setItem('pageHistory', JSON.stringify(pageHistory));
    }
    // next();
  // });

  if (!authpage && !loggeduser) {
    return next(process.env.VUE_APP_DB_URI + '/login');
  }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // try {
  //   // For each matched route...
  //   for (const route of routeTo.matched) {
  //     await new Promise((resolve, reject) => {
  //       // If a `beforeResolve` hook is defined, call it with
  //       // the same arguments as the `beforeEnter` hook.
  //       if (route.meta && route.meta.beforeResolve) {
  //         route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
  //           // If the user chose to redirect...
  //           if (args.length) {
  //             // If redirecting to the same route we're coming from...
  //             // Complete the redirect.
  //             next(...args);
  //             reject(new Error('Redirected'));
  //           } else {
  //             resolve();
  //           }
  //         });
  //       } else {
  //         // Otherwise, continue resolving the route.
  //         resolve();
  //       }
  //     });
  //   }
  //   // If a `beforeResolve` hook chose to redirect, just return.
  // } catch (error) {
  //   return;
  // }
  // document.title = routeTo.meta.title + ' | ' + appConfig.title;
  document.title = appConfig.title;
  // If we reach this point, continue resolving the route.
  next();
});

export default router;
